// Security Action Type

//Security auth role list
export const GET_SECURITY_AUTH_ROLE_LIST = "GET_SECURITY_AUTH_ROLE_LIST";
export const GET_SECURITY_AUTH_ROLE_LIST_SUCCESS =
  "GET_SECURITY_AUTH_ROLE_LIST_SUCCESS";
export const GET_SECURITY_AUTH_ROLE_LIST_FAILURE =
  "GET_SECURITY_AUTH_ROLE_LIST_FAILURE";

// Security auth role by id
export const GET_SECURITY_AUTH_ROLE_BY_ID = "GET_SECURITY_AUTH_ROLE_BY_ID";
export const GET_SECURITY_AUTH_ROLE_BY_ID_SUCCESS =
  "GET_SECURITY_AUTH_ROLE_BY_ID_SUCCESS";
export const GET_SECURITY_AUTH_ROLE_BY_ID_FAILURE =
  "GET_SECURITY_AUTH_ROLE_BY_ID_FAILURE";

// Security auth role create
export const CREATE_SECURITY_AUTH_ROLE = "CREATE_SECURITY_AUTH_ROLE";
export const CREATE_SECURITY_AUTH_ROLE_SUCCESS =
  "CREATE_SECURITY_AUTH_ROLE_SUCCESS";
export const CREATE_SECURITY_AUTH_ROLE_FAILURE =
  "CREATE_SECURITY_AUTH_ROLE_FAILURE";

// Security auth role update
export const UPDATE_SECURITY_AUTH_ROLE = "UPDATE_SECURITY_AUTH_ROLE";
export const UPDATE_SECURITY_AUTH_ROLE_SUCCESS =
  "UPDATE_SECURITY_AUTH_ROLE_SUCCESS";
export const UPDATE_SECURITY_AUTH_ROLE_FAILURE =
  "UPDATE_SECURITY_AUTH_ROLE_FAILURE";

// Security auth role delete
export const DELETE_SECURITY_AUTH_ROLE = "DELETE_SECURITY_AUTH_ROLE";
export const DELETE_SECURITY_AUTH_ROLE_SUCCESS =
  "DELETE_SECURITY_AUTH_ROLE_SUCCESS";
export const DELETE_SECURITY_AUTH_ROLE_FAILURE =
  "DELETE_SECURITY_AUTH_ROLE_FAILURE";

//Master security auth capability list
export const GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST =
  "GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST";
export const GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_SUCCESS =
  "GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_SUCCESS";
export const GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_FAILURE =
  "GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_FAILURE";

///securityauthroletouser/list
export const GET_SECURITY_AUTH_ROLE_TO_USER_LIST =
  "GET_SECURITY_AUTH_ROLE_TO_USER_LIST";
export const GET_SECURITY_AUTH_ROLE_TO_USER_LIST_SUCCESS =
  "GET_SECURITY_AUTH_ROLE_TO_USER_LIST_SUCCESS";
export const GET_SECURITY_AUTH_ROLE_TO_USER_LIST_FAILURE =
  "GET_SECURITY_AUTH_ROLE_TO_USER_LIST_FAILURE";

///securityauthroletouser/create
export const CREATE_SECURITY_AUTH_ROLE_TO_USER =
  "CREATE_SECURITY_AUTH_ROLE_TO_USER";
export const CREATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS =
  "CREATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS";
export const CREATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE =
  "CREATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE";

///securityauthroletouser/update - Task 24736, StartDate/EndDate only
export const UPDATE_SECURITY_AUTH_ROLE_TO_USER =
  "UPDATE_SECURITY_AUTH_ROLE_TO_USER";
export const UPDATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS =
  "UPDATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS";
export const UPDATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE =
  "UPDATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE";

///securityauthroletouser/delete
export const DELETE_SECURITY_AUTH_ROLE_TO_USER =
  "DELETE_SECURITY_AUTH_ROLE_TO_USER";
export const DELETE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS =
  "DELETE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS";
export const DELETE_SECURITY_AUTH_ROLE_TO_USER_FAILURE =
  "DELETE_SECURITY_AUTH_ROLE_TO_USER_FAILURE";

///securityauthmissingrequest/create
export const CREATE_SECURITY_AUTH_MISSING_REQUEST =
  "CREATE_SECURITY_AUTH_MISSING_REQUEST";
export const CREATE_SECURITY_AUTH_MISSING_REQUEST_SUCCESS =
  "CREATE_SECURITY_AUTH_MISSING_REQUEST_SUCCESS";
export const CREATE_SECURITY_AUTH_MISSING_REQUEST_FAILURE =
  "CREATE_SECURITY_AUTH_MISSING_REQUEST_FAILURE";
